import {dataHooks} from '@wix/data-hooks'

export const reservationAddOnFormDataHooks = dataHooks<{
  root: {}
  location: {}
  partySize: {}
  date: {}
  time: {}
}>('reservation-addon-form')
